import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed";
}

// Indian currency formatting (₹, Lakh, Crore)
export function fmtCurrency(n, withSymbol = true) {
  const num = Number(n) || 0;
  const sym = withSymbol ? "₹" : "";
  const abs = Math.abs(num);
  if (abs >= 1e7) return `${sym}${(num / 1e7).toFixed(2)}Cr`;
  if (abs >= 1e5) return `${sym}${(num / 1e5).toFixed(2)}L`;
  return `${sym}${num.toLocaleString("en-IN")}`;
}

export function fmtNumber(n) {
  return (Number(n) || 0).toLocaleString("en-IN");
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}

export const ROLE_LABELS = {
  super_admin: "Platform Super Admin",
  company_admin: "Company Admin",
  sales_manager: "Sales Manager",
  salesperson: "Salesperson",
  viewer: "Viewer",
};

export const COUNTRIES = [
  "India", "Nigeria", "Vietnam", "Brazil", "UAE", "Kenya", "Mexico", "Philippines",
  "South Africa", "Egypt", "Sri Lanka", "Ghana", "Tanzania", "Myanmar", "Bangladesh",
  "Indonesia", "Thailand", "Colombia", "Peru", "Morocco", "Saudi Arabia", "Oman",
];
